module.exports = __webpack_public_path__ + "site/img/footerzh.96be9199.png";